@if (todo.status === 'pending') {
<icon type="x" color="red"></icon>
} @if (todo.status === 'completed') {
<icon type="check2" color="green"></icon>
} @if (todo.link != null && isPrevTodoComplete(todo)) {
<a [routerLink]="routerLinkElements" [queryParams]="params"> {{ todo.text }}</a>
} @else {
{{ todo.text }}
}
